import type { MarketConfigDTO } from '../../features/settings/types/settings.types';

export function RewardMarketSelect({ markets, value, disabled, onChange }: {
  markets: MarketConfigDTO[]; value: string; disabled: boolean; onChange: (value: string) => void;
}) {
  return <label className="block max-w-xs space-y-1">
    <span className="text-sm font-medium text-gray-700">配置地区</span>
    <select value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)}
      className="h-10 w-full rounded-md border border-gray-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50">
      {markets.map((market) => <option key={market.market_id} value={market.market_id}>
        {market.market_id} · {market.name}
      </option>)}
    </select>
  </label>;
}
